import { API_ROUTES } from '../constants';
import utils from '../utils';

const maintenance = () => ({
  getScheduledMaintenance: (
    onActiveMaintenance: (endDateTime: string, message: string) => void,
    onNoMaintenance: () => void,
    onError: () => void,
    applicationType?: string,
  ) => {
    utils
      .fetch(
        `${API_ROUTES.maintenance.scheduleMaintenance}?applicationType=${applicationType}`,
      )
      .then((res) => {
        if (res && res.response) {
          const { endDateTime, message, active } = res.response;
          if (active) {
            onActiveMaintenance(endDateTime, message);
          } else {
            onNoMaintenance();
          }
        }
      })
      .catch(() => {
        onError();
      });
  },
  
  //for ca
  getCaId: () => {
    return utils.fetch(API_ROUTES.maintenance.caId, {
      method: 'GET',    
    });
  },
});

export default maintenance;
